/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    AHmet Dogramaci
 * Date      2020-03-16
 */
import IsSelected from "../enums/is-selected";
import IsHidden from "../enums/is-hidden";
import IsDisabled from "../enums/is-disabled";

class ConfigurationTemplateNode {
    constructor(id) {
        this.id = id;
        this.is_selected_value = IsSelected.NO;
        this.is_hidden_value = IsHidden.NO;
        this.is_disabled_value = IsDisabled.NO;
        this.decision_watches = [];
        this.or_group_watches = [];
        this.decision_triggers = [];
        this.decision_actions = [];
        this.template_version = null;
        this.calculated_price_transformations = {};
        this.traces_array     = [];
        this.last_sequence    = 0;
    }

    setTemplateVersion(template_version){
        this.template_version = template_version;
    }

    buildFromJson(json_object){
        this.id = json_object.id;
        this.code = json_object.code;
        this.name = json_object.name;
        this.cfg_item_id = json_object.cfg_item_id;
        this.attribute_store = json_object.attribute_store;
        if(json_object.calculated_price_transformations){
            json_object.calculated_price_transformations.forEach((price_object)=>{
                this.calculated_price_transformations[price_object['name']]=price_object['value'];
            });
        }
    }

    addOrGroupWatch(or_group_watch){
        this.or_group_watches.push(or_group_watch);
    }

    addDecisionWatch(decision_watch){
        this.decision_watches.push(decision_watch);
    }

    addDecisionTrigger(decision_trigger){
        this.decision_triggers.push(decision_trigger);
    }

    addDecisionAction(decision_action){
        this.decision_actions.push(decision_action);
    }

    get is_selected(){
        return this.is_selected_value;
    }

    set is_selected(value){
        if (this.is_selected_value !== value) {
            this.is_selected_value = value;
            console.log(`Node:${this.code} is_selected:${value}`)
            this.triggerWatches();
        }
    }

    get is_hidden(){
        return this.is_hidden_value;
    }

    set is_hidden(value){
        if (this.is_hidden_value !== value) {
            this.is_hidden_value = value;
            this.triggerWatches();
        }
    }

    get is_disabled(){
        return this.is_disabled_value;
    }

    set is_disabled(value){
        if (this.is_disabled_value !== value) {
            this.is_disabled_value = value;
            this.triggerWatches();
        }
    }

    get isSelected() {
        return this.is_selected_value === IsSelected.YES;
    }

    get isUnselected() {
        return this.is_selected_value === IsSelected.NO;
    }

    get isHidden() {
        return this.is_hidden_value === IsHidden.YES;
    }

    get isVisible() {
        return this.is_hidden_value === IsHidden.NO;
    }

    get isDisabled() {
        return this.is_disabled_value === IsDisabled.YES;
    }

    get isEnabled() {
        return this.is_disabled_value === IsDisabled.NO;
    }

    get traces(){
        return this.traces_array;
    }

    select() {
        this.is_selected = IsSelected.YES;
    }

    unselect() {
        this.is_selected = IsSelected.NO;
    }

    show() {
        this.is_hidden = IsHidden.NO;
    }

    hide() {
        this.is_hidden = IsHidden.YES;
    }

    enable() {
        this.is_disabled = IsDisabled.NO;
    }

    disable() {
        this.is_disabled = IsDisabled.YES;
    }

    triggerWatches(){
        for(let i=0; i < this.decision_watches.length; i++){
            let watch = this.decision_watches[i];
            watch.triggerDecisionEvaluation();
        }
        for(let i=0; i < this.or_group_watches.length; i++){
            let watch = this.or_group_watches[i];
            watch.triggerEvaluation();
        }
        for(let i=0; i < this.decision_triggers.length; i++){
            let trigger = this.decision_triggers[i];
            trigger.evaluateDecision();
        }
    }

    addTrace(message){
        this.last_sequence+=1;
        this.traces_array.push({sequence:this.last_sequence,message:message});
    }
    resetTraces(){
        this.last_sequence=0;
        this.traces_array.splice(0);
    }

}
export default ConfigurationTemplateNode;